import styled from 'styled-components';
export const AddressAutocompleteContainer = styled.div `
  .ant-form-item-control {
    flex: auto;
  }
`;
